import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "as-line-ups" }
const _hoisted_2 = { class: "as-back-green" }
const _hoisted_3 = { class: "as-line-ups-info" }
const _hoisted_4 = { class: "as-line-ups-info-item" }
const _hoisted_5 = { class: "as-line-ups-info-item" }
const _hoisted_6 = { class: "as-ground-box" }
const _hoisted_7 = {
  key: 0,
  class: "as-formation as-formation-home"
}
const _hoisted_8 = { class: "as-lineup-players" }
const _hoisted_9 = {
  key: 1,
  class: "as-formation as-formation-away"
}
const _hoisted_10 = { class: "as-note" }

import { ref, computed } from "vue";
import type {
  ILineups,
  IMatch,
  IPlayer,
  IIncidentStatistic,
  IStartingPlayers,
} from "~src/interfaces";
import Players from "~src/components/lineups/Players.vue";
import SquadItem from "~src/components/lineups/SquadItem.vue";import MatchEnum from "~src/enums/MatchEnum";
import IconStadium from "~src/components/icons/IconStadium.vue";
import { getWeatherDetail } from "~src/helpers";

const __default__ = {};

interface IProps {
  lineups: ILineups;
  match: IMatch;
  startingPlayers: IStartingPlayers;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Squad',
  props: {
    lineups: {},
    match: {},
    startingPlayers: {}
  },
  setup(__props: any) {

;
const props = __props;

const listIncidents: IIncidentStatistic[] = MatchEnum.INCIDENT_LIST;

const lineupsHomeAway = computed(() => {
  const filterByStatus = (team: IPlayer[]) => {
    return team && Array.isArray(team)
      ? team.filter((player) => player.first === 1)
      : [];
  };
  let home: IPlayer[] = [],
    away: IPlayer[] = [];
  if (props.lineups.id) {
    try {
      home = filterByStatus(props.lineups.lineup.home);
      away = filterByStatus(props.lineups.lineup.away);
    } catch (error) {
      console.error("Error filtering lineups:", error);
    }
  }

  return {
    home,
    away,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(IconStadium),
          _createTextVNode(" " + _toDisplayString(_ctx.lineups.venue?.name || '--'), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_unref(getWeatherDetail)(_ctx.lineups.environment?.weather || 0)), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.lineups.environment?.temperature || '--'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.lineups.home_formation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.lineups.home_formation), 1))
          : _createCommentVNode("", true),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-mid-circle" }, [
          _createElementVNode("div", { class: "as-mid-inner" })
        ], -1)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['home', 'away'], (team, key) => {
          return _createElementVNode("div", {
            key: key,
            class: _normalizeClass(["as-w-100 as-half-box", {
            'as-half-box-away': team === 'away',
          }])
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "as-square2" }, [
              _createElementVNode("div", { class: "as-square1" })
            ], -1)),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-w-100" }, [
              _createElementVNode("div", { class: "as-circle" })
            ], -1)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(SquadItem, {
                players: 
                team === 'home' ? lineupsHomeAway.value.home : lineupsHomeAway.value.away
              ,
                teamType: team
              }, null, 8, ["players", "teamType"]),
              _createVNode(SquadItem, {
                players: 
                team === 'home' ? lineupsHomeAway.value.home : lineupsHomeAway.value.away
              ,
                screen: "sm",
                teamType: team
              }, null, 8, ["players", "teamType"])
            ])
          ], 2)
        }), 64)),
        (_ctx.lineups.away_formation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.lineups.away_formation), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listIncidents), (incident, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "as-note-item"
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(incident.icon))),
          _createTextVNode(_toDisplayString(incident.label), 1)
        ]))
      }), 128))
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "as-squad-title" }, [
      _createElementVNode("span", null, "Dự bị")
    ], -1)),
    _createVNode(Players, {
      match: _ctx.match,
      lineups: _ctx.lineups,
      startingPlayers: _ctx.startingPlayers,
      isSubstituted: true
    }, null, 8, ["match", "lineups", "startingPlayers"])
  ]))
}
}

})